import $http from '../../utils/http';

const guidePath = 'team-supervision-backend/api/guide_backend'; // 导游的服务
const travelPath = 'team-supervision-backend/api/travel'

const authCheckTioPermission = params => {
  return $http({
    url: '/tio/auth/checkTioPermission',
    params
  });
};
const indexAddressbook = params => {
  return $http({
    url: '/tio/index/addressbook',
    params
  });
};

const addressbookbyid = params => {
  return $http({
    url: '/tio/index/addressbookbyid',
    params,
    headers: {'showLoading': false}
  });
};
const getAddressbookbyid = params => {
  return $http({
    url: '/tio/index/getAddressBookByCodeOrId',
    params,
    headers: {'showLoading': false}
  });
};
const searchaddressbook = params => {
  return $http({
    url: '/tio/index/searchaddressbook',
    params
    // headers: { 'showLoading': false }
  });
};

export const indexdesc = params => {
  // 获取权限
  return $http({
    url: '/tio/index/desc',
    params
  });
};

// 首页获取各模块权限
const getLimits = params => {
  return $http({
    url: '/tio/auth/getAuth',
    params
  });
};

// 首页获取投诉模块权限
const getComplainLimits = params => {
  return $http({
    url: '/tio/complain/getindexauth',
    params
  });
};

// 首页获取退货模块权限
const getRefundLimits = params => {
  return $http({
    url: '/tio/refund/getindexauth',
    params
  });
};

// 首页获取诚信模块权限
const getIntegrityLimits = params => {
  return $http({
    url: '/tio/integrity/api/auth/tioUserPermission',
    params
  });
};

// 首页获取考核模块权限
const getJudgeLimits = params => {
  return $http({
    url: '/tio/assess/judgeAssessStaffPriv',
    params
  });
};

// 首页投诉
export const workbench = data => {
  // 获取首页用户信息
  return $http({
    url: '/tio/complain/qywx/newWorkbench/workbench',
    data,
    method: 'POST'
  });
};

// 首页退货领导组接口
export const workbenchLeader = params => {
  // 领导组首页数据统计
  return $http({
    url: 'tio/refund/api/refund/home/leader/workbench',
    params,
    method: 'GET'
  });
};

// 首页州市考核分数接口
export const accessScore = params => {
  // 领导组首页数据统计
  return $http({
    url: 'tio/assess/getAssessScoreByQuarter',
    params,
    method: 'GET'
  });
};

export const guideCityList = params => {
  // 城市列表
  return $http({
    url: 'tio/lxsdygl/common/cityList',
    params,
    method: 'get'
  });
};

// export const getIndexUserInfo = params => {
//   // 头部用户信息
//   return $http({
//     url: 'tio/personal/info',
//     params,
//     method: 'get'
//   });
// };

export const getIndexUserInfo = params => {
  // 头部用户信息 -- 更换
  return $http({
    url: 'tio/personal/getIndexInfo',
    params,
    method: 'get'
  });
};

export const lately30Trendhome = params => {
  // 获取当前日期前三十天数据
  return $http({
    url: 'tio/refund/api/refund/last30day/trend',
    params
  });
};
export const noticeNumGuide = params => {
  // 获取导游待办
  return $http({
    // url: 'tio/lxsdygl/home/guide/todo',
    // url: guidePath + '/evaluation/api/blacklist/travel/todoGuideList',
    url: guidePath + '/blacklist/guide/todoGuideList',
    params,
    headers: {'showLoading': false}
  });
};
export const noticeNumTravel = params => {
  // 获取旅行社待办
  return $http({
    // url: 'tio/lxsdygl/todo/number',
    url: travelPath + '/evaluation/api/blacklist/travel/todoTravelList',
    // url: 'tio/lxsdygl/home/travel/todo',
    params,
    headers: {'showLoading': false}
  });
};

export const noticeNumComplain = params => {
  // 获取投诉待办
  return $http({
    url: 'tio/complain/todo/number',
    params,
    headers: {'showLoading': false}
  });
};

export const noticeNumIntegrity = params => {
  // 获取诚信待办
  return $http({
    url: 'tio/integrity/todo/number',
    params,
    headers: {'showLoading': false}
  });
};

export const noticeNumRefund = params => {
  // 获取退货待办
  return $http({
    url: 'tio/refund/todo/number',
    params,
    headers: {'showLoading': false}
  });
};

export const rewardUp = data => {
  // 提交反馈信息
  return $http({
    url: '/tio/personal/feedback',
    data,
    method: 'POST'
  });
};
export const handleNum = data => {
  // 首页投诉待办
  return $http({
    url: '/tio/complain/qywx/handleNum/list',
    data,
    method: 'POST'
  });
};
export const todoList = params => {
  // 首页退货待办
  return $http({
    url: 'tio/refund/api/refund/todo/me',
    params,
  });
};
// /lxsdygl/pc/guide/findGuideTodo
export const todoGuideList = params => {
  // 首页导游待办列表
  return $http({
    // url: guidePath + '/evaluation/api/blacklist/travel/todoGuideList',
    url: guidePath + '/blacklist/guide/todoGuideList',
    params
  });
};
export const NoticeTrava = params => {
  // 首页旅行社待办统计
  return $http({
    url: 'tio/lxsdygl/home/travel/todo',
    params
  });
};
export const todoTravelList = params => {
  // 首页旅行社待办列表
  return $http({
    // url: 'tio/lxsdygl/evaluation/api/blacklist/travel/todoTravelList',
    url: travelPath + '/evaluation/api/blacklist/travel/todoTravelList',
    params
  });
};
export const todoInnerList = params => {
  // 首页诚信待办
  return $http({
    url: '/tio/integrity/api/task/todo/list',
    params
  });
};

export const getUnionAuth = params => {
  // 首页诚信待办
  return $http({
    url: 'tio/index/getUnionAuth',
    params
  });
};

export const getStaffCode = params => {
  // 获取用户信息
  return $http({
    url: 'tio/index/getStaffCode',
    params
  });
};

export const getSign = params => {
  // 获取签名
  return $http({
    url: 'tio/im/common/gen-sig',
    params
  });
};

export const importAccount = data => {
  // 导入用户信息
  return $http({
    url: 'tio/im/account/import',
    data,
    method: 'POST',
    isPayload: true
  });
};

/**
 * 获取团队监管权限
 * @param {*} data 
 * @returns 
 */
export const getTouristPrivacyLimit = data => {
  return $http({
    url: `/team-supervision-backend/api/team-supervision/api/itinerary/touristPrivacy/pageByCondition`,
    data: {
      page: 1, 
      size:100, 
      data:{"waitAudit": true}
    },
    baseURL: process.env.VUE_APP_BASE_URL,
    method: 'POST',
    isPayload: true
  });
};

export default {
  authCheckTioPermission,
  searchaddressbook,
  indexAddressbook,
  lately30Trendhome,
  getLimits,
  workbench,
  workbenchLeader,
  getComplainLimits,
  getRefundLimits,
  getIntegrityLimits,
  getJudgeLimits,
  guideCityList,
  accessScore,
  getIndexUserInfo,
  addressbookbyid,
  noticeNumTravel,
  noticeNumGuide,
  noticeNumComplain,
  noticeNumIntegrity,
  noticeNumRefund,
  rewardUp,
  getAddressbookbyid,
  handleNum,
  todoList,
  todoGuideList,
  todoTravelList,
  todoInnerList,
  NoticeTrava,
  getUnionAuth,
  getStaffCode,
  getSign,
  importAccount,
  getTouristPrivacyLimit,
};
